import React, { useReducer, createContext } from 'react';
import jwtDecode from 'jwt-decode';

const initialState = {
  user: null
};

// If token exists in localStorage, decode it and fill data in state
let tokenLocalStorage = localStorage.getItem('jwtToken');
if (tokenLocalStorage) {
  const decodedToken = tokenDecoder(tokenLocalStorage);
  // Check if token was successfully decoded
  if (decodedToken) initialState.user = decodedToken;
}

const AuthContext = createContext({
  user: null,
  login: userData => {},
  logout: () => {}
});

function authReducer(state, action) {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        user: action.payload
      };
    case 'LOGOUT':
      if (localStorage.getItem('user'))
        localStorage.removeItem('user')
      return {
        ...state,
        user: null
      };
    default:
      return state;
  }
}

function AuthProvider(props) {
  const [state, dispatch] = useReducer(authReducer, initialState);

  function login(token) {
    // Save token in localStorage
    localStorage.setItem('jwtToken', token);
    // Decode it
    const decodedToken = tokenDecoder(token);

    // Dispatch action
    dispatch({
      type: 'LOGIN',
      payload: decodedToken
    });
  }

  function logout() {
    localStorage.removeItem('jwtToken');
    dispatch({ type: 'LOGOUT' });
  }

  return (
    <AuthContext.Provider
      value={{ user: state.user, login, logout }}
      {...props}
    />
  );
}

function tokenDecoder(token) {
  // Decode token
  const decodedToken = jwtDecode(token);

  // Check for expiration
  if (decodedToken.exp * 1000 < Date.now()) {
    localStorage.removeItem('jwtToken');
    return null;
  }

  return decodedToken;
}

export { AuthContext, AuthProvider };
